export default __webpack_public_path__ + "static/media/18.e545cc18.jpg";